export enum TabType {
  Summary = "summary",
  Examples = "examples",
  Insights = "insight",
  Positions = "position",
  Transactions = "transaction",
  Monthly = "monthly",
  Daily = "daily",
  Portfolios = "portfolio",
  RiskVsReturn = "risk-vs-return",
  ScenarioAnalysis = "scenario-analysis",
}

const BaseViews = [
  { name: "Summary", id: "summary" },
  { name: "Insights", id: "insight" },
];
const DailyView = { name: "Daily", id: "daily" };

const MonthlyView = { name: "Monthly", id: "monthly" };
const RiskVsReturnView = { name: "Risk Vs Return", id: "risk-vs-return" };
const ScenarioAnalysisView = {
  name: "Scenario Analysis",
  id: "scenario-analysis",
};
export const IncomeViews = [...BaseViews];
export const NetWorthViews = [...BaseViews];
export const PnlViews = [BaseViews[0], MonthlyView, BaseViews[1]];
export const PerformanceViews = [BaseViews[0], MonthlyView, BaseViews[1]];
export const RiskViews = [
  DailyView,
  MonthlyView,
  RiskVsReturnView,
  ScenarioAnalysisView,
  BaseViews[1],
];
export const EsgViews = [...BaseViews];

export const PositionViews = [
  { name: "Positions", id: TabType.Positions },
  { name: "Transactions", id: TabType.Transactions },
];

export const PortfolioGroupViews = [
  { name: "Clients", id: TabType.Summary },

  { name: "Portfolios", id: TabType.Portfolios },
  { name: "Example Portfolios", id: TabType.Examples },
];
